import { getTopicType } from "@cappelendamm/crystallize-utils";
/** Crystallize paths of the shop topics among these, e.g. "/nettbutikker/krimklubben" */
export const getShopTopicPaths = (topics) => (topics ?? [])
    .map((topic) => topic?.path)
    .filter((path) => typeof path === "string" && getTopicType(path) === "shop");
export const getSubscriptionShopTopics = (subscription) => {
    const topics = subscription.product?.topics ?? [];
    return topics
        .filter((topic) => {
        const path = topic?.path;
        return typeof path === "string" && getTopicType(path) === "shop";
    })
        .map((topic) => topic?.name?.trim())
        .filter((topicName) => Boolean(topicName));
};
/** Crystallize paths of the subscription's shop topics */
export const getSubscriptionShopTopicPaths = (subscription) => getShopTopicPaths(subscription.product?.topics);
